var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.4167H8.33333V8.75H9.16667C9.40278 8.75 9.60069 8.67014 9.76042 8.51042C9.92014 8.35069 10 8.15278 10 7.91667V7.08333C10 6.84722 9.92014 6.64931 9.76042 6.48958C9.60069 6.32986 9.40278 6.25 9.16667 6.25H7.5V10.4167ZM8.33333 7.91667V7.08333H9.16667V7.91667H8.33333ZM10.8333 10.4167H12.5C12.7361 10.4167 12.934 10.3368 13.0938 10.1771C13.2535 10.0174 13.3333 9.81944 13.3333 9.58333V7.08333C13.3333 6.84722 13.2535 6.64931 13.0938 6.48958C12.934 6.32986 12.7361 6.25 12.5 6.25H10.8333V10.4167ZM11.6667 9.58333V7.08333H12.5V9.58333H11.6667ZM14.1667 10.4167H15V8.75H15.8333V7.91667H15V7.08333H15.8333V6.25H14.1667V10.4167ZM6.66667 15C6.20833 15 5.81597 14.8368 5.48958 14.5104C5.16319 14.184 5 13.7917 5 13.3333V3.33333C5 2.875 5.16319 2.48264 5.48958 2.15625C5.81597 1.82986 6.20833 1.66667 6.66667 1.66667H16.6667C17.125 1.66667 17.5174 1.82986 17.8437 2.15625C18.1701 2.48264 18.3333 2.875 18.3333 3.33333V13.3333C18.3333 13.7917 18.1701 14.184 17.8437 14.5104C17.5174 14.8368 17.125 15 16.6667 15H6.66667ZM6.66667 13.3333H16.6667V3.33333H6.66667V13.3333ZM3.33333 18.3333C2.875 18.3333 2.48264 18.1701 2.15625 17.8437C1.82986 17.5174 1.66667 17.125 1.66667 16.6667V5H3.33333V16.6667H15V18.3333H3.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PdfIcon.7b8e6ce7.svg";
export { ForwardRef as ReactComponent };